/** Odczyt tokenu z fragmentu URL (#token=...) — bez wycieku przez Referer. */
export function authTokenFromHash(): string {
  const raw = window.location.hash.replace(/^#/, "").trim();
  if (!raw) {
    return "";
  }
  const params = new URLSearchParams(raw.includes("=") ? raw : `token=${raw}`);
  return params.get("token")?.trim() || "";
}
